import { useNavigate } from "react-router-dom";
import MainContainer from "../../../layout/MainContainer";
import AlertList from "../../../features/budgetIntelligence/alertConfiguration/alertList";
import { Box, Tabs, Tab } from "@mui/material";
import React from "react";
import TonesList from "../../../features/budgetIntelligence/alertConfiguration/tonesList";


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const AlertsConfiguration = () => {

  const navigate = useNavigate();

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  return (
    <>
      <div className="main_title">
        <h1>Alerts Configuration</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Alerts Configuration
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Alerts" {...a11yProps(0)} />
              <Tab label="Tones" {...a11yProps(1)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <AlertList />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <TonesList />
        </CustomTabPanel>
      </div>
    </>
  );
};

export default AlertsConfiguration;
